import { ClientResources, PersonDto } from '@app/api2/api';
import * as Yup from 'yup';

export type BiographicalTypeMembers = Pick<PersonDto, 'id' | 'labId' | 'enrollmentPurposeId' | 'isEnrollmentCompleted' | 'firstName' | 'lastName' | 'middleName' | 'secondLastName' | 'dob' | 'sexId' | 'nationalityId' | 'agencyCaseNumber' | 'agencyOri' | 'fbiNumber' | 'sidNumber'>;

export const BiographicalSchema: (t: ClientResources) => Yup.SchemaOf<BiographicalTypeMembers> = (t) => {
    return Yup.object({
        id: Yup.number().optional().meta({ search: false }),
        isEnrollmentCompleted: Yup.boolean().optional().meta({ search: false }),
        labId: Yup.number().optional().nullable().meta({ search: false }),
        enrollmentPurposeId: Yup.number().label(t.metadata.enrollmentPurposeLabel || 'Enrollment Purpose').required(),
        lastName: Yup.string().max(80).label(t.metadata.lastName).required(),
        firstName: Yup.string().max(80).label(t.metadata.firstName).required(),
        dob: Yup.date().label(t.metadata.dateOfBirth).required().test('future-date', t.metadata.dateOfBirthFuture || 'Date of Birth cannot be in the future', (value) => {
            if (!value) return true; // Skip if not provided
            return value <= new Date();
        }) as any,
        sexId: Yup.number().label(t.metadata.sexLabel).nullable().optional(),
        secondLastName: Yup.string().max(80).label(t.metadata.secondLastNameLabel).optional(),
        agencyCaseNumber: Yup.string().max(12).label(t.metadata.agencyCaseNumberLabel).optional(),
        agencyOri: Yup.string().max(9).label(t.metadata.agencyOriLabel).optional(),
        fbiNumber: Yup.string().label(t.metadata.fbiNumberLabel).optional(),
        middleName: Yup.string().max(80).label(t.metadata.middleName).optional(),
        sidNumber: Yup.string().max(100).label(t.metadata.sidNumberLabel || 'SID Number (State ID)').optional(),
        nationalityId: Yup.number().label(t.metadata.nationalityLabel || 'Nationality').optional().nullable(),
    })
};

// https://dev.to/scooperdev/generate-array-of-all-an-interfaces-keys-with-typescript-4hbf
type BiographicalTypeMembersObject = Record<(keyof BiographicalTypeMembers), undefined>;

const bioDefProperties: BiographicalTypeMembersObject = {
    id: undefined,
    labId: undefined,
    isEnrollmentCompleted: undefined,
    enrollmentPurposeId: undefined,
    lastName: undefined,
    secondLastName: undefined,
    firstName: undefined,
    middleName: undefined,
    dob: undefined,
    sexId: undefined,
    nationalityId: undefined,
    agencyOri: undefined,
    agencyCaseNumber: undefined,
    fbiNumber: undefined,
    sidNumber: undefined,
};

export const ALL_BIO_PROPERTIES = Object.keys(bioDefProperties) as (keyof BiographicalTypeMembers)[];